import { useEffect, useState } from 'react'
import dayjs from '@/lib/dayjs'

const ACTIVE_WINDOW_MS = 5 * 60 * 1000

export default function ProfileLastActivity({ lastSeenAt, disabled = false, emptyLabel = 'Non enregistrée' }) {
    const [now, setNow] = useState(Date.now)
    const timestamp = lastSeenAt ? dayjs(lastSeenAt).valueOf() : NaN

    useEffect(() => {
        if (!Number.isFinite(timestamp)) return

        let timer
        const refresh = () => {
            const currentTime = Date.now()
            setNow(currentTime)
            const remaining = timestamp + ACTIVE_WINDOW_MS - currentTime
            timer = setTimeout(refresh, remaining > 0 ? Math.min(remaining, 60000) : 60000)
        }
        refresh()
        return () => clearTimeout(timer)
    }, [timestamp])

    if (!Number.isFinite(timestamp)) return emptyLabel

    const age = now - timestamp
    const isActive = !disabled && age >= 0 && age < ACTIVE_WINDOW_MS

    return (
        <time dateTime={lastSeenAt} title={dayjs(lastSeenAt).format('DD/MM/YYYY HH:mm:ss')}>
            {isActive ? 'Moins de 5 minutes' : dayjs(lastSeenAt).locale('fr').from(dayjs(now))}
        </time>
    )
}
